import React from "react"

const BlockHero = ({ title, description, children }) => {
  return (
    <div className="blockHero-container">
      <div className="borderA"></div>
      <div className="content">
        {children ? (
          children
        ) : (
          <>
            <div className="title">{title}</div>{" "}
            <div className="description"> {description} </div>{" "}
          </>
        )}
      </div>
      <div className="borderB"></div>
    </div>
  )
}

export default BlockHero
